import { createRequest } from '../helpers/api_utils';
import { apiUrl, faceUrl } from './api_url';

const apiEndpoint = apiUrl + '/storage';
const faceApiEndpoint = faceUrl + '/detect-face';

export function getStorageLink(filename: string, folder: string) {
  const body = {
    file_name: filename,
    folder: folder,
  };
  return fetch(createRequest(apiEndpoint, 'POST', 'application/json', true, body))
    .then(response => {
      return response.json();
    });
}

export function detectFace(imageBase64: string) {
  const body = {
    imageBase64: imageBase64,
  };
  return fetch(createRequest(faceApiEndpoint, 'POST', 'application/json', true, body));
}

export function awsUpload(url: string, image: Blob) {
  const response = fetch(url, {
    method: 'PUT',
    body: image,
  });
  return response;
}

export function awsUploadVideo(url: string, video: Blob) {
  const response = fetch(url, {
    method: 'PUT',
    body: video,
  });
  return response;
}

export function awsUploadVideov(
  url: string,
  video: Blob,
  onProgress: (percent: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('PUT', url, true);

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable) return;

      const percent = (event.loaded / event.total) * 50; // 🔑 AWS = 0–50%
      onProgress(percent);
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(50); // ensure it caps at 50%
        resolve();
      } else {
        reject(new Error(`AWS upload failed: ${xhr.status}`));
      }
    };

    xhr.onerror = () => reject(new Error('AWS upload error'));

    xhr.send(video);
  });
}

export function getVideoFromStorage(filePath: string) {
  const queryParams = new URLSearchParams({
    file_path: filePath,
  });

  const url = `${apiEndpoint}?${queryParams.toString()}`;

  return fetch(createRequest(url, 'GET', 'application/json', true)).then(
    (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch video: ${response.statusText}`);
      }
      // For video streaming, we might get the response as a blob or a redirect
      // Check if it's a JSON response first (containing the actual URL)
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return response.json().then((data) => {
          if (typeof data === 'string') return data;
          return data.url || data.videoUrl || data.downloadUrl || data.signedUrl;
        });
      } else {
        // If it's a direct video stream, return the response URL
        return response.url;
      }
    },
  );
}
